import React from 'react';

import {
	perfMark,
	WATERFALL_INITIAL_MEASURES,
} from '@confluence/action-measures/entry-points/WaterfallMeasures';

import { SSRThemeInit } from './SSRThemeInit';

export const SSRAppTheme = ({ uri }: { uri: string }) => (
	<>
		{perfMark(`${WATERFALL_INITIAL_MEASURES.HTML_THEME_INIT}.start`)}
		<SSRThemeInit uri={uri} />
		{perfMark(`${WATERFALL_INITIAL_MEASURES.HTML_THEME_INIT}.end`)}
	</>
);
